<template>
  <v-container id="ur-list">
    <v-row>
      <v-col
        ><h3><b>Perguntas</b></h3></v-col
      >
      <v-col class="text-right">
        <app-modal-insert
          :edit="false"
          :object="null"
          :color="'success'"
          :icon="'mdi-plus-circle'"
        >
          <template v-slot:title :edit="false"> Cadastrar Pergunta </template>
        </app-modal-insert>
      </v-col>
    </v-row>

    <v-row>
      <v-col>
        <v-data-table
          :headers="headers"
          :items="payload"
          class="elevation-1"
          hide-default-footer
          disable-pagination
        >
          <template v-slot:item.nacional="{ item }">
            <span>
              {{ item.nacional ? "Sim" : "Não" }}
            </span>
          </template>
          <template v-slot:item.temaId="{ item }">
            <span>
              {{ item.temaName }}
            </span>
          </template>

          <template v-slot:item.acoes="{ item }">
            <v-row v-if="!item.nacional || isFullAdmin">
              <v-col cols="1">
                <app-modal-insert
                  :object="item"
                  :edit="true"
                  :color="'warning'"
                  :icon="'mdi-pencil'"
                >
                  <template v-slot:title> Editar Pergunta </template>
                </app-modal-insert>
              </v-col>
            </v-row>
          </template>

          <template v-slot:item.acoes_delete="{ item }">
            <v-row v-if="!item.nacional || isFullAdmin">
              <v-col cols="1">
                <app-modal-delete :object="item">
                  <template v-slot:title> Deletar </template>
                </app-modal-delete>
              </v-col>

              <v-col cols="1"> </v-col>
            </v-row>
          </template>

          <template slot="no-data">
            <span> Nenhuma Pergunta retornada </span>
          </template>
        </v-data-table>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
import AppModalInsert from "./ModalInsert";
import { perguntaAPI } from "../API/Pergunta";
import { mapActions, mapGetters } from "vuex";
import AppModalDelete from "./../components/ModalDelete";
export default {
  components: {
    AppModalInsert,
    AppModalDelete,
  },
  data() {
    return {
      headers: [
        { text: "Número", value: "numero", width: "150px" },
        { text: "Pontos", value: "pontos", width: "150px" },
        { text: "Texto", value: "texto", width: "150px" },
        { text: "Tema", value: "temaId", width: "150px" },
        { text: "Nacional", value: "nacional", width: "150px" },
        { text: "Editar", value: "acoes", width: "150px", sortable: false },
        {
          text: "Excluir",
          value: "acoes_delete",
          width: "150px",
          sortable: false,
        },
      ],
      payload: [],
      mappedPayload: [],
      temas: [],
      temaAtual: {},
    };
  },
  methods: {
    ...mapActions(["setLoading"]),
    loadTemas() {
      return perguntaAPI.getTemas();
    },
    loadPerguntas() {
      this.setLoading(true);
      perguntaAPI
        .list()
        .then(({ data }) => {
          this.payload = data;
          this.payload.forEach((element) => {
            element.temaName = this.temas.filter(
              (item) => item.temaId === element.temaId
            )[0].nome;
          });

          this.setLoading(false);
        })
        .catch((resp) => {
          this.setLoading(false);
          this.$notification.error("Erro ao obter Perguntas");
        });
    },
  },
  async mounted() {
    await this.loadTemas()
      .then((resp) => {
        this.temas = resp.data;
      })
      .catch();

    this.loadPerguntas();
  },
  computed: {
    ...mapGetters(["isFullAdmin"]),
  },
};
</script>
